import React, {useState} from 'react';
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography
} from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {useNavigate} from 'react-router-dom';
import {Logout, ToggleOff, ToggleOn} from '@mui/icons-material';
import {AutopilotSearchBox} from '../../components/search/AutopilotSearchBox';
import {TestProdToggle} from '../../components/buttons/TestProdToggle';
import Divider from "@mui/material/Divider";
import {ChristmasLights, isHolidaySeason} from '../../components/ChristmasLights';
import {useDarkMode} from '../../contexts/DarkModeContext';

// Snowman Icon Component - using emoji for clarity
const SnowmanIcon: React.FC<{ sx?: any }> = ({ sx }) => (
  <Box
    sx={{
      fontSize: '20px',
      lineHeight: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...sx,
    }}
  >
    ☃️
  </Box>
);

export function HeaderBar() {

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const menuOpen = Boolean(anchorEl);
  const [isUTC, setIsUTC] = useState(() => {
    return localStorage.getItem("isUTC") === "true";
  });
  const [lightsVisible, setLightsVisible] = useState(() => {
    const saved = localStorage.getItem("christmasLightsVisible");
    return saved === null ? true : saved === "true"; // Default to true if not set
  });
  const { darkMode, toggleDarkMode } = useDarkMode();

  const navigator = useNavigate();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUTCClick = () => {
    setIsUTC((prev) => {
      const newValue = !prev;
      localStorage.setItem("isUTC", newValue.toString());
      window.location.reload()
      return newValue;
    });
  };

  const handleLightsToggle = () => {
    setLightsVisible((prev) => {
      const newValue = !prev;
      localStorage.setItem("christmasLightsVisible", newValue.toString());
      return newValue;
    });
  };

  return <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
    <Toolbar sx={{
      backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'lightgray' : 'black',
    }}>
      <div onClick={(e) => {
        if (e.metaKey || e.ctrlKey) {
          window.open(`/`);
        } else {
          navigator(`/`)}
      }} style={{cursor: 'pointer', display: 'flex', alignContent: 'left', alignItems: 'center'}}>
        <img src="/wheel-icon.png" style={{ height: '1.8rem', borderRadius: '8px'}} alt="Logo" />
        <Typography noWrap component="div" sx={{ marginLeft: '10px',
          color: (theme) => theme.palette.mode === 'dark' ? 'black' : 'white',
          font: 'Roboto',
          fontWeight: 500,
          fontSize: '18px',
          letterSpacing: '0.05em',
        }}>
          AUTOPILOT ADMIN
        </Typography>
      </div>
      <Box sx={{ flexGrow: 1 }} />
      <Typography variant="body1" noWrap component="div" sx={{ marginLeft: '10px',
        color: (theme) => theme.palette.mode === 'dark' ? 'black' : 'white',}}>
        Customer Search:
      </Typography>
      <AutopilotSearchBox />
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ width: '50%', display: 'flex', alignItems: 'center', textAlign: 'center', justifyContent: 'space-around'}}>
        <div onClick={(e) => {
          if (e.metaKey || e.ctrlKey) {
            window.open(`/pilots`);
          } else {
            navigator(`/pilots`)}
        }}
             style={{cursor: 'pointer', display: 'flex', alignContent: 'left', alignItems: 'center'}}>
          <Typography variant="h6" noWrap component="div" sx={{ marginLeft: '10px',
            color: (theme) => theme.palette.mode === 'dark' ? 'black' : 'white',
            font: 'Roboto',
            fontWeight: 500,
            fontSize: '17px',
            letterSpacing: '0.05em',
          }}>
            PILOTS
          </Typography>
        </div>
        <div onClick={(e) => {
          if (e.metaKey || e.ctrlKey) {
            window.open(`/assets`);
          } else {
            navigator(`/assets`)}
        }}
          style={{cursor: 'pointer', display: 'flex', alignContent: 'left', alignItems: 'center'}}>
          <Typography variant="h6" noWrap component="div" sx={{ marginLeft: '10px',
            color: (theme) => theme.palette.mode === 'dark' ? 'black' : 'white',
            font: 'Roboto',
            fontWeight: 500,
            fontSize: '17px',
            letterSpacing: '0.05em',
          }}>
            ASSETS
          </Typography>
        </div>
        <div onClick={(e) => {
          if (e.metaKey || e.ctrlKey) {
            window.open(`/developer/workflows`);
          } else {
            navigator(`/developer/workflows`)}
        }}
          style={{cursor: 'pointer', display: 'flex', alignContent: 'left', alignItems: 'center'}}>
          <Typography variant="h6" noWrap component="div" sx={{ marginLeft: '10px',
            color: (theme) => theme.palette.mode === 'dark' ? 'black' : 'white',
            font: 'Roboto',
            fontWeight: 500,
            fontSize: '17px',
            letterSpacing: '0.05em',
          }}>
            DEVELOPER PORTAL
          </Typography>
        </div>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Box>
        <TestProdToggle />
      </Box>
      {isHolidaySeason() && (
        <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', marginLeft: '8px', marginRight: '8px' }}>
          <Tooltip title={lightsVisible ? "Hide Christmas lights" : "Show Christmas lights"}>
            <Box
              onClick={handleLightsToggle}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 12px',
                borderRadius: '4px',
                border: lightsVisible
                  ? (theme) => `1px solid ${theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.3)'}`
                  : (theme) => `1px solid ${theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.2)'}`,
                backgroundColor: lightsVisible
                  ? (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.1)'
                  : (theme) => theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.1)' : 'rgba(0,0,0,0.1)',
                color: lightsVisible 
                  ? (theme) => theme.palette.mode === 'dark' ? 'black' : 'white'
                  : (theme) => theme.palette.mode === 'dark' ? '#666' : '#999',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: lightsVisible
                    ? (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.2)'
                    : (theme) => theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.2)',
                  transform: 'scale(1.05)',
                },
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              <SnowmanIcon />
              <Typography
                variant="caption"
                sx={{
                  fontSize: '12px',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                {lightsVisible ? 'On' : 'Off'}
              </Typography>
            </Box>
          </Tooltip>
        </Box>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Account settings">
          <IconButton onClick={handleClick} size="small">
            <Avatar sx={{ width: 40, height: 40 }}><PersonOutlineIcon /></Avatar>
          </IconButton>
        </Tooltip>
        <Menu
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleUTCClick}>
            <ListItemIcon>
              {isUTC ? <ToggleOn fontSize="medium" color={'primary'}/> : <ToggleOff fontSize="medium" />}
            </ListItemIcon>
            Toggle UTC
          </MenuItem>
          <MenuItem onClick={toggleDarkMode}>
            <ListItemIcon>
              {darkMode ? <ToggleOn fontSize="medium" color={'primary'}/> : <ToggleOff fontSize="medium" />}
            </ListItemIcon>
            Toggle Dark Mode
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => {
            handleClose();
            navigator('/logout');
          }}>
            <ListItemIcon>
              <Logout fontSize="medium" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Toolbar>
    {lightsVisible && <ChristmasLights />}
  </AppBar>;
}